var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Viewport_convertDOMPosToMoveDistance, _Viewport_roundToNearestHalf, _Viewport_getDevicePixelRatio, _Viewport_setPositionPercentageValueX, _Viewport_setPositionPercentageValueY, _Viewport_setPosition, _Viewport_setScale, _Viewport_getViewportCenterPosPx, _Viewport_getViewportCenterPosPxUnscaled, _Viewport_getPercentageOfArtworkFocusedCenterPos, _Viewport_getPxPosFromPercentagePos, _Viewport_getPxPosFromPercentagePosUnscaled, _Viewport_getVisibleTilesByLevel, _Viewport_getVisibleTilesByLevelUnscaled, _Viewport_setVisibleTiles, _Viewport_preloadOtherLevelTiles, _Viewport_setNextLevel, _Viewport_setPrevLevel, _Viewport_handleZoomValue, _Viewport_zoomAnimated, _Viewport_moveAnimated, _Viewport_moveAnimatedToPointerPosition, _Viewport_countZoomStep, _Viewport_convertPercentageToPx, _Viewport_convertPxToPercentage, _Viewport_cancelMoveAnimation, _Viewport_cancelZoomAnimation, _Viewport_getPointPositionFromArtwork, _Viewport_getPointPositionFromViewport, _Viewport_countInitialScaleValue;
import { ALLOW_ANY_MOVEMENT_WITHOUT_BOUNDARIES, EXTRA_IMAGES_ON_EACH_SIDE_COUNT, FORCE_DPR_VALUE, INITIAL_ZOOM_SPACING_PERCENTAGE, IS_FORCE_DPR, MOVE_SPEED_MULTIPLIER, PER_LEVELS_MULTIPLIER, PRELOAD_OTHER_LEVELS_TILES, PREVENT_IMAGE_PLACEMENT_BESIDE_BOUNDARIES, SET_CLOSEST_AVAILABLE_MOVEMENT_POSITION, TILE_SIZE, UPDATE_POINTER_POSITION_WHILE_SCROLL_ZOOMING, USE_UNSCALED_VISIBLE_TILES, ZOOM_AMOUNT_MULTIPLIER, CENTER_LOCK_UNSCALED, INCREASE_MAX_ZOOM_REGARDLESS_OF_DPR, ZOOM_ANIM_TIME, MOVE_ANIM_TIME, MAX_ZOOM_PERCENTAGE, } from '../consts';
import { easeInOutQuad, easeLinear, easeOutSine } from '../utils/easing';
export class Viewport {
    constructor(layers, initialLevel, zoomLevelsList, initialViewportSize, useDpr) {
        Object.defineProperty(this, "fullImageProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "previousFullImageProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "VIEWPORT_SIZE", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "VIEWPORT_SIZE_INITIAL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "VIEWPORT_SIZE_UNSCALED", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "posPercentageX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "posPercentageY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "level", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "scaleMax", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 1
        });
        Object.defineProperty(this, "scaleMin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.scaleMax / PER_LEVELS_MULTIPLIER
        });
        Object.defineProperty(this, "scaleInitial", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "scale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "zoomPercentage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "zoomPercentageMin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "zoomPercentageMax", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "zoomPercentageTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "storedInitialPositionX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "storedInitialPositionY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "storedInitialZoomPercentage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isZooming", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "pointerPositionX", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pointerPositionY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "moveCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "previewerCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onVisibleTilesChangeCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "clearImagesLevelCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => null
        });
        Object.defineProperty(this, "onLevelChangeCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "layers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "visibleTiles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                firstX: 0,
                firstY: 0,
                lastX: 0,
                lastY: 0,
            }
        });
        Object.defineProperty(this, "zoomLevelsList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "devicePixelRatio", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "zoomAnimFrame", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "moveAnimFrame", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "useDpr", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setInitialPositionToFitDOMElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (placeholderElement) => {
                const placeholderProps = placeholderElement.getBoundingClientRect();
                const desiredZoomPercentage = (placeholderProps.width / this.layers.at(-1).width) * 100 * this.devicePixelRatio;
                if (desiredZoomPercentage < this.zoomPercentageMin) {
                    this.zoomPercentageMin = desiredZoomPercentage;
                }
                if (desiredZoomPercentage > this.zoomPercentageMax) {
                    this.zoomPercentageMax = desiredZoomPercentage;
                }
                this.setZoomLevel(desiredZoomPercentage);
                const [moveX, moveY] = __classPrivateFieldGet(this, _Viewport_convertDOMPosToMoveDistance, "f").call(this, placeholderProps.left + placeholderProps.width / 2, placeholderProps.top + placeholderProps.height / 2);
                __classPrivateFieldGet(this, _Viewport_setPosition, "f").call(this, 0, 0);
                this.movePosition(moveX, moveY);
                this.storedInitialZoomPercentage = desiredZoomPercentage;
                this.storedInitialPositionX = this.posPercentageX;
                this.storedInitialPositionY = this.posPercentageY;
            }
        });
        Object.defineProperty(this, "animateTransitionToViewerPosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (animTime = ZOOM_ANIM_TIME) => {
                return new Promise((resolve, reject) => {
                    const targetZoom = __classPrivateFieldGet(this, _Viewport_countInitialScaleValue, "f").call(this);
                    const animationTimingFunction = easeInOutQuad;
                    const zoomAnimation = __classPrivateFieldGet(this, _Viewport_zoomAnimated, "f").call(this, targetZoom, false, false, animTime, animationTimingFunction);
                    const moveAnimation = __classPrivateFieldGet(this, _Viewport_moveAnimated, "f").call(this, -this.posPercentageX, -this.posPercentageY, animTime, animationTimingFunction);
                    Promise.all([zoomAnimation, moveAnimation])
                        .then(() => {
                        resolve();
                    })
                        .catch(() => {
                        reject('anim error');
                    });
                });
            }
        });
        Object.defineProperty(this, "animateTransitionToPreviewPosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (animTime = ZOOM_ANIM_TIME) => {
                return new Promise((resolve, reject) => {
                    const animationTimingFunction = easeInOutQuad;
                    const zoomAnimation = __classPrivateFieldGet(this, _Viewport_zoomAnimated, "f").call(this, this.storedInitialZoomPercentage, false, false, animTime, animationTimingFunction);
                    const moveAnimation = __classPrivateFieldGet(this, _Viewport_moveAnimated, "f").call(this, this.storedInitialPositionX - this.posPercentageX, this.storedInitialPositionY - this.posPercentageY, animTime, animationTimingFunction);
                    Promise.all([zoomAnimation, moveAnimation])
                        .then(() => {
                        resolve();
                    })
                        .catch(() => {
                        reject('anim error');
                    });
                });
            }
        });
        _Viewport_convertDOMPosToMoveDistance.set(this, (posX, posY) => {
            return [
                posX - ((this.VIEWPORT_SIZE.w / 2) * this.scale) / this.devicePixelRatio,
                posY - ((this.VIEWPORT_SIZE.h / 2) * this.scale) / this.devicePixelRatio,
            ];
        });
        _Viewport_roundToNearestHalf.set(this, (number) => Math.round(number * 2) / 2);
        _Viewport_getDevicePixelRatio.set(this, () => {
            if (IS_FORCE_DPR)
                return FORCE_DPR_VALUE;
            if (this.useDpr)
                return window?.devicePixelRatio ?? 1;
            return 1;
        });
        _Viewport_setPositionPercentageValueX.set(this, (x) => {
            this.posPercentageX = x;
        });
        _Viewport_setPositionPercentageValueY.set(this, (y) => {
            this.posPercentageY = y;
        });
        _Viewport_setPosition.set(this, (newPosInPercentageX, newPosInPercentageY) => {
            const viewportCenterPos = __classPrivateFieldGet(this, _Viewport_getViewportCenterPosPx, "f").call(this);
            const viewportHalfInPercentage = __classPrivateFieldGet(this, _Viewport_convertPxToPercentage, "f").call(this, viewportCenterPos[0], viewportCenterPos[1]);
            const viewportLeftBound = -viewportHalfInPercentage[0] * this.scale;
            const viewportRightBound = viewportHalfInPercentage[0] * this.scale;
            const viewportTopBound = -viewportHalfInPercentage[1] * this.scale;
            const viewportBottomBound = viewportHalfInPercentage[1] * this.scale;
            const fullImagePropsWidth = this.fullImageProps.width;
            const fullImagePropsHeight = this.fullImageProps.height;
            const imageLeftBorder = newPosInPercentageX - 50;
            const imageRightBorder = newPosInPercentageX + 50;
            const imageTopBorder = newPosInPercentageY - 50;
            const imageBottomBorder = newPosInPercentageY + 50;
            const isImageBiggerThanViewportWidth = fullImagePropsWidth > this.VIEWPORT_SIZE.w;
            const isImageBiggerThanViewportHeight = fullImagePropsHeight > this.VIEWPORT_SIZE.h;
            const isLeftDirection = newPosInPercentageX < this.posPercentageX;
            const isRightDirection = newPosInPercentageX > this.posPercentageX;
            const isUpDirection = newPosInPercentageY < this.posPercentageY;
            const isDownDirection = newPosInPercentageY > this.posPercentageY;
            const isPositionValNotChanged = this.posPercentageX === newPosInPercentageX && this.posPercentageY === newPosInPercentageY;
            const halfSizeInPercentage = 50;
            if (ALLOW_ANY_MOVEMENT_WITHOUT_BOUNDARIES) {
                if (isLeftDirection || isRightDirection) {
                    __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, newPosInPercentageX);
                }
                if (isUpDirection || isDownDirection) {
                    __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, newPosInPercentageY);
                }
            }
            else {
                if (isLeftDirection) {
                    if (isImageBiggerThanViewportWidth) {
                        if (imageRightBorder > viewportRightBound) {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, newPosInPercentageX);
                        }
                        else {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, viewportRightBound - halfSizeInPercentage);
                        }
                    }
                    else {
                        if (CENTER_LOCK_UNSCALED) {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, 0);
                        }
                        else {
                            if (imageLeftBorder > viewportLeftBound) {
                                __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, newPosInPercentageX);
                            }
                            else {
                                if (SET_CLOSEST_AVAILABLE_MOVEMENT_POSITION) {
                                    if (this.posPercentageX - halfSizeInPercentage > viewportLeftBound)
                                        __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, viewportLeftBound + halfSizeInPercentage);
                                }
                            }
                        }
                    }
                }
                if (isRightDirection) {
                    if (isImageBiggerThanViewportWidth) {
                        if (imageLeftBorder < viewportLeftBound) {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, newPosInPercentageX);
                        }
                        else {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, viewportLeftBound + halfSizeInPercentage);
                        }
                    }
                    else {
                        if (CENTER_LOCK_UNSCALED) {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, 0);
                        }
                        else {
                            if (imageRightBorder < viewportRightBound) {
                                __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, newPosInPercentageX);
                            }
                            else {
                                if (SET_CLOSEST_AVAILABLE_MOVEMENT_POSITION) {
                                    if (this.posPercentageX + halfSizeInPercentage < viewportRightBound)
                                        __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, viewportRightBound - halfSizeInPercentage);
                                }
                            }
                        }
                    }
                }
                if (isUpDirection) {
                    if (isImageBiggerThanViewportHeight) {
                        if (imageBottomBorder > viewportBottomBound) {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, newPosInPercentageY);
                        }
                        else {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, viewportBottomBound - halfSizeInPercentage);
                        }
                    }
                    else {
                        if (CENTER_LOCK_UNSCALED) {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, 0);
                        }
                        else {
                            if (imageTopBorder > viewportTopBound) {
                                __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, newPosInPercentageY);
                            }
                            else {
                                if (SET_CLOSEST_AVAILABLE_MOVEMENT_POSITION) {
                                    if (this.posPercentageY - halfSizeInPercentage > viewportTopBound)
                                        __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, viewportTopBound + halfSizeInPercentage);
                                }
                            }
                        }
                    }
                }
                if (isDownDirection) {
                    if (isImageBiggerThanViewportHeight) {
                        if (imageTopBorder < viewportTopBound) {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, newPosInPercentageY);
                        }
                        else {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, viewportTopBound + halfSizeInPercentage);
                        }
                    }
                    else {
                        if (CENTER_LOCK_UNSCALED) {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, 0);
                        }
                        else {
                            if (imageBottomBorder < viewportBottomBound) {
                                __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, newPosInPercentageY);
                            }
                            else {
                                if (SET_CLOSEST_AVAILABLE_MOVEMENT_POSITION) {
                                    if (this.posPercentageY + halfSizeInPercentage < viewportBottomBound)
                                        __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, viewportBottomBound - halfSizeInPercentage);
                                }
                            }
                        }
                    }
                }
            }
            if (isPositionValNotChanged &&
                PREVENT_IMAGE_PLACEMENT_BESIDE_BOUNDARIES &&
                !ALLOW_ANY_MOVEMENT_WITHOUT_BOUNDARIES) {
                if (isImageBiggerThanViewportWidth) {
                    if (imageLeftBorder > viewportLeftBound) {
                        __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, viewportLeftBound + halfSizeInPercentage);
                    }
                    else {
                        if (imageRightBorder < viewportRightBound) {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, viewportRightBound - halfSizeInPercentage);
                        }
                    }
                }
                else {
                    if (imageLeftBorder < viewportLeftBound) {
                        __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, viewportLeftBound + halfSizeInPercentage);
                    }
                    else if (imageRightBorder > viewportRightBound) {
                        __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueX, "f").call(this, viewportRightBound - halfSizeInPercentage);
                    }
                }
                if (isImageBiggerThanViewportHeight) {
                    if (imageTopBorder > viewportTopBound) {
                        __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, viewportTopBound + halfSizeInPercentage);
                    }
                    else {
                        if (imageBottomBorder < viewportBottomBound) {
                            __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, viewportBottomBound - halfSizeInPercentage);
                        }
                    }
                }
                else {
                    if (imageTopBorder < viewportTopBound) {
                        __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, viewportTopBound + halfSizeInPercentage);
                    }
                    else if (imageBottomBorder > viewportBottomBound) {
                        __classPrivateFieldGet(this, _Viewport_setPositionPercentageValueY, "f").call(this, viewportBottomBound - halfSizeInPercentage);
                    }
                }
            }
            if (this.previewerCallback)
                this.previewerCallback();
        });
        _Viewport_setScale.set(this, (val, moveX = 0, moveY = 0) => {
            this.previousFullImageProps.width = this.fullImageProps.width;
            this.previousFullImageProps.height = this.fullImageProps.height;
            this.scale = val;
            this.VIEWPORT_SIZE = {
                x: this.VIEWPORT_SIZE_INITIAL.x / val,
                y: this.VIEWPORT_SIZE_INITIAL.y / val,
                w: this.VIEWPORT_SIZE_INITIAL.w / val,
                h: this.VIEWPORT_SIZE_INITIAL.h / val,
            };
            __classPrivateFieldGet(this, _Viewport_setVisibleTiles, "f").call(this);
            if (moveX || moveY)
                this.movePosition(moveX, moveY);
        });
        _Viewport_getViewportCenterPosPx.set(this, () => {
            const viewportCenterX = this.VIEWPORT_SIZE.x + this.VIEWPORT_SIZE.w / 2;
            const viewportCenterY = this.VIEWPORT_SIZE.y + this.VIEWPORT_SIZE.h / 2;
            return [viewportCenterX, viewportCenterY];
        });
        _Viewport_getViewportCenterPosPxUnscaled.set(this, () => {
            if (!this.VIEWPORT_SIZE_UNSCALED)
                return [0, 0];
            const viewportCenterX = this.VIEWPORT_SIZE_UNSCALED.x + this.VIEWPORT_SIZE_UNSCALED.w / 2;
            const viewportCenterY = this.VIEWPORT_SIZE_UNSCALED.y + this.VIEWPORT_SIZE_UNSCALED.h / 2;
            return [viewportCenterX, viewportCenterY];
        });
        _Viewport_getPercentageOfArtworkFocusedCenterPos.set(this, (posX, posY) => {
            const levelScaling = this.fullImageProps.width / this.previousFullImageProps.width;
            const viewportCenter = __classPrivateFieldGet(this, _Viewport_getViewportCenterPosPx, "f").call(this);
            const pctX = ((viewportCenter[0] - posX) / this.fullImageProps.width) * 100;
            const pctY = ((viewportCenter[1] - posY) / this.fullImageProps.height) * 100;
            return [pctX * levelScaling, pctY * levelScaling];
        });
        _Viewport_getPxPosFromPercentagePos.set(this, (posPercentageX, posPercentageY) => {
            const viewportCenter = __classPrivateFieldGet(this, _Viewport_getViewportCenterPosPx, "f").call(this);
            const posPxX = this.VIEWPORT_SIZE.w - viewportCenter[0] + (posPercentageX * this.fullImageProps.width) / 100;
            const posPxY = this.VIEWPORT_SIZE.h - viewportCenter[1] + (posPercentageY * this.fullImageProps.height) / 100;
            return [posPxX, posPxY];
        });
        _Viewport_getPxPosFromPercentagePosUnscaled.set(this, (posPercentageX, posPercentageY) => {
            if (!this.VIEWPORT_SIZE_UNSCALED)
                return [0, 0];
            const viewportCenterUnscaled = __classPrivateFieldGet(this, _Viewport_getViewportCenterPosPxUnscaled, "f").call(this);
            const posPxX = this.VIEWPORT_SIZE_UNSCALED.w - viewportCenterUnscaled[0] + (posPercentageX * this.fullImageProps.width) / 100;
            const posPxY = this.VIEWPORT_SIZE_UNSCALED.h - viewportCenterUnscaled[1] + (posPercentageY * this.fullImageProps.height) / 100;
            return [posPxX, posPxY];
        });
        _Viewport_getVisibleTilesByLevel.set(this, (requestedLevel, extraImagesOnEachSideCount = 0) => {
            if (!this.layers[requestedLevel])
                return {
                    firstX: 0,
                    lastX: 0,
                    firstY: 0,
                    lastY: 0,
                };
            const fieldSizeX = this.layers[requestedLevel].countX;
            const fieldSizeY = this.layers[requestedLevel].countY;
            const levelTileSizeMultiplier = Math.pow(PER_LEVELS_MULTIPLIER, requestedLevel - this.level);
            const pos = __classPrivateFieldGet(this, _Viewport_getPxPosFromPercentagePos, "f").call(this, this.posPercentageX, this.posPercentageY);
            const centerPositionX = pos[0];
            const centerPositionY = pos[1];
            const viewAreaStartAtX = -centerPositionX + this.VIEWPORT_SIZE.x + this.fullImageProps.width / 2;
            const viewAreaEndAtX = -centerPositionX + this.VIEWPORT_SIZE.x + this.VIEWPORT_SIZE.w + this.fullImageProps.width / 2;
            const viewAreaStartAtY = -centerPositionY + this.VIEWPORT_SIZE.y + this.fullImageProps.height / 2;
            const viewAreaEndAtY = -centerPositionY + this.VIEWPORT_SIZE.y + this.VIEWPORT_SIZE.h + this.fullImageProps.height / 2;
            const tileSizeX = TILE_SIZE[0] / levelTileSizeMultiplier;
            const tileSizeY = TILE_SIZE[1] / levelTileSizeMultiplier;
            let firstVisibleTileX = Math.floor(viewAreaStartAtX / tileSizeX);
            let lastVisibleTileX = Math.floor(viewAreaEndAtX / tileSizeX);
            let firstVisibleTileY = Math.floor(viewAreaStartAtY / tileSizeY);
            let lastVisibleTileY = Math.floor(viewAreaEndAtY / tileSizeY);
            firstVisibleTileX -= extraImagesOnEachSideCount;
            lastVisibleTileX += extraImagesOnEachSideCount;
            firstVisibleTileY -= extraImagesOnEachSideCount;
            lastVisibleTileY += extraImagesOnEachSideCount;
            const fieldSizeLastIndexX = fieldSizeX - 1;
            const fieldSizeLastIndexY = fieldSizeY - 1;
            if (firstVisibleTileX < 0)
                firstVisibleTileX = 0;
            if (firstVisibleTileY < 0)
                firstVisibleTileY = 0;
            if (lastVisibleTileX > fieldSizeLastIndexX)
                lastVisibleTileX = fieldSizeLastIndexX;
            if (lastVisibleTileY > fieldSizeLastIndexY)
                lastVisibleTileY = fieldSizeLastIndexY;
            return {
                firstX: firstVisibleTileX,
                firstY: firstVisibleTileY,
                lastX: lastVisibleTileX,
                lastY: lastVisibleTileY,
            };
        });
        _Viewport_getVisibleTilesByLevelUnscaled.set(this, (requestedLevel, extraImagesOnEachSideCount = 0) => {
            if (!this.layers[requestedLevel] || !this.VIEWPORT_SIZE_UNSCALED)
                return {
                    firstX: 0,
                    lastX: 0,
                    firstY: 0,
                    lastY: 0,
                };
            const fieldSizeX = this.layers[requestedLevel].countX;
            const fieldSizeY = this.layers[requestedLevel].countY;
            const levelTileSizeMultiplier = Math.pow(PER_LEVELS_MULTIPLIER, requestedLevel - this.level);
            const pos = __classPrivateFieldGet(this, _Viewport_getPxPosFromPercentagePosUnscaled, "f").call(this, this.posPercentageX, this.posPercentageY);
            const centerPositionX = pos[0];
            const centerPositionY = pos[1];
            const viewAreaStartAtX = -centerPositionX + this.VIEWPORT_SIZE_UNSCALED.x + this.fullImageProps.width / 2;
            const viewAreaEndAtX = -centerPositionX + this.VIEWPORT_SIZE_UNSCALED.x + this.VIEWPORT_SIZE_UNSCALED.w + this.fullImageProps.width / 2;
            const viewAreaStartAtY = -centerPositionY + this.VIEWPORT_SIZE_UNSCALED.y + this.fullImageProps.height / 2;
            const viewAreaEndAtY = -centerPositionY + this.VIEWPORT_SIZE_UNSCALED.y + this.VIEWPORT_SIZE_UNSCALED.h + this.fullImageProps.height / 2;
            const tileSizeX = TILE_SIZE[0] / levelTileSizeMultiplier;
            const tileSizeY = TILE_SIZE[1] / levelTileSizeMultiplier;
            let firstVisibleTileX = Math.floor(viewAreaStartAtX / tileSizeX);
            let lastVisibleTileX = Math.floor(viewAreaEndAtX / tileSizeX);
            let firstVisibleTileY = Math.floor(viewAreaStartAtY / tileSizeY);
            let lastVisibleTileY = Math.floor(viewAreaEndAtY / tileSizeY);
            firstVisibleTileX -= extraImagesOnEachSideCount;
            lastVisibleTileX += extraImagesOnEachSideCount;
            firstVisibleTileY -= extraImagesOnEachSideCount;
            lastVisibleTileY += extraImagesOnEachSideCount;
            const fieldSizeLastIndexX = fieldSizeX - 1;
            const fieldSizeLastIndexY = fieldSizeY - 1;
            if (firstVisibleTileX < 0)
                firstVisibleTileX = 0;
            if (firstVisibleTileY < 0)
                firstVisibleTileY = 0;
            if (lastVisibleTileX > fieldSizeLastIndexX)
                lastVisibleTileX = fieldSizeLastIndexX;
            if (lastVisibleTileY > fieldSizeLastIndexY)
                lastVisibleTileY = fieldSizeLastIndexY;
            return {
                firstX: firstVisibleTileX,
                firstY: firstVisibleTileY,
                lastX: lastVisibleTileX,
                lastY: lastVisibleTileY,
            };
        });
        _Viewport_setVisibleTiles.set(this, () => {
            let isUpdated = false;
            const countedVisibleTiles = USE_UNSCALED_VISIBLE_TILES
                ? __classPrivateFieldGet(this, _Viewport_getVisibleTilesByLevelUnscaled, "f").call(this, this.level, EXTRA_IMAGES_ON_EACH_SIDE_COUNT)
                : __classPrivateFieldGet(this, _Viewport_getVisibleTilesByLevel, "f").call(this, this.level, EXTRA_IMAGES_ON_EACH_SIDE_COUNT);
            if (this.visibleTiles.firstX !== countedVisibleTiles.firstX)
                isUpdated = true;
            if (this.visibleTiles.lastX !== countedVisibleTiles.lastX)
                isUpdated = true;
            if (this.visibleTiles.firstY !== countedVisibleTiles.firstY)
                isUpdated = true;
            if (this.visibleTiles.lastY !== countedVisibleTiles.lastY)
                isUpdated = true;
            if (isUpdated) {
                this.visibleTiles = countedVisibleTiles;
                __classPrivateFieldGet(this, _Viewport_preloadOtherLevelTiles, "f").call(this);
            }
        });
        _Viewport_preloadOtherLevelTiles.set(this, () => {
            requestAnimationFrame(() => {
                if (this.onVisibleTilesChangeCallback) {
                    const nextLevel = this.level + 1;
                    const prevLevel = this.level - 1;
                    if (!this.isZooming)
                        this.onVisibleTilesChangeCallback?.(this.level, this.visibleTiles);
                    if (PRELOAD_OTHER_LEVELS_TILES) {
                        if (!this.isZooming) {
                            const diffMin = Math.abs(this.scale - this.scaleMin);
                            const diffMax = Math.abs(this.scale - this.scaleMax);
                            if (diffMin < diffMax) {
                                this.onVisibleTilesChangeCallback?.(prevLevel, __classPrivateFieldGet(this, _Viewport_getVisibleTilesByLevel, "f").call(this, prevLevel, EXTRA_IMAGES_ON_EACH_SIDE_COUNT));
                                this.clearImagesLevelCache(nextLevel);
                            }
                            else {
                                this.onVisibleTilesChangeCallback?.(nextLevel, __classPrivateFieldGet(this, _Viewport_getVisibleTilesByLevel, "f").call(this, nextLevel, EXTRA_IMAGES_ON_EACH_SIDE_COUNT));
                                this.clearImagesLevelCache(prevLevel);
                            }
                        }
                    }
                    else {
                        this.clearImagesLevelCache(prevLevel);
                        this.clearImagesLevelCache(nextLevel);
                    }
                }
            });
        });
        _Viewport_setNextLevel.set(this, () => {
            this.level++;
            this.setFullImageProps({
                width: this.layers[this.level].width,
                height: this.layers[this.level].height,
            });
            if (this.onLevelChangeCallback)
                this.onLevelChangeCallback(this.level);
        });
        _Viewport_setPrevLevel.set(this, () => {
            this.level--;
            this.setFullImageProps({
                width: this.layers[this.level].width,
                height: this.layers[this.level].height,
            });
            if (this.onLevelChangeCallback)
                this.onLevelChangeCallback(this.level);
        });
        _Viewport_handleZoomValue.set(this, (value) => {
            const targetPercentage = value < this.zoomPercentageMin
                ? this.zoomPercentageMin
                : value > this.zoomPercentageMax
                    ? this.zoomPercentageMax
                    : value;
            let nextLevelPercentage = null;
            let prevLevelPercentage = null;
            const thisLevelPercentage = this.zoomLevelsList[this.level].sizeRaw;
            if (this.zoomLevelsList[this.level + 1])
                nextLevelPercentage = this.zoomLevelsList[this.level + 1].sizeRaw;
            if (this.zoomLevelsList[this.level - 1])
                prevLevelPercentage = this.zoomLevelsList[this.level - 1].sizeRaw;
            const handleScalingOnCurrentLevel = () => {
                __classPrivateFieldGet(this, _Viewport_setScale, "f").call(this, targetPercentage / thisLevelPercentage);
                this.zoomPercentage = targetPercentage;
            };
            if (nextLevelPercentage && targetPercentage > thisLevelPercentage) {
                __classPrivateFieldGet(this, _Viewport_setNextLevel, "f").call(this);
                __classPrivateFieldGet(this, _Viewport_setScale, "f").call(this, this.scaleMin);
                this.zoomPercentage = thisLevelPercentage;
                __classPrivateFieldGet(this, _Viewport_handleZoomValue, "f").call(this, targetPercentage);
            }
            else {
                if (prevLevelPercentage && targetPercentage < prevLevelPercentage) {
                    __classPrivateFieldGet(this, _Viewport_setPrevLevel, "f").call(this);
                    __classPrivateFieldGet(this, _Viewport_setScale, "f").call(this, this.scaleMax);
                    this.zoomPercentage = prevLevelPercentage;
                    __classPrivateFieldGet(this, _Viewport_handleZoomValue, "f").call(this, targetPercentage);
                }
                else {
                    handleScalingOnCurrentLevel();
                }
            }
        });
        _Viewport_zoomAnimated.set(this, (zoomValue, setPointerPosition = false, setCenterPosition = false, zoomAnimTime = ZOOM_ANIM_TIME, animationTimingFunction = easeLinear) => {
            __classPrivateFieldGet(this, _Viewport_cancelZoomAnimation, "f").call(this);
            return new Promise((resolve) => {
                const zoomPercentage = this.zoomPercentage;
                let targetZoomPercentage = zoomValue;
                targetZoomPercentage =
                    targetZoomPercentage >= this.zoomPercentageMax
                        ? this.zoomPercentageMax
                        : targetZoomPercentage <= this.zoomPercentageMin
                            ? this.zoomPercentageMin
                            : targetZoomPercentage;
                this.zoomPercentageTarget = targetZoomPercentage;
                const startTime = Date.now();
                const animZoomAmount = targetZoomPercentage - zoomPercentage;
                const storedPointerToArtworkPos = __classPrivateFieldGet(this, _Viewport_getPointPositionFromArtwork, "f").call(this, this.pointerPositionX, this.pointerPositionY);
                const storedPointerPos = [this.pointerPositionX, this.pointerPositionY];
                let elapsed = 0;
                const animateZoom = () => {
                    if (elapsed <= zoomAnimTime) {
                        this.isZooming = true;
                        const currentTime = Date.now();
                        elapsed = currentTime - startTime;
                        const progress = animationTimingFunction(elapsed / zoomAnimTime);
                        const zoomAmount = zoomPercentage + animZoomAmount * progress;
                        __classPrivateFieldGet(this, _Viewport_handleZoomValue, "f").call(this, zoomAmount);
                        if (elapsed < zoomAnimTime) {
                            this.zoomAnimFrame = requestAnimationFrame(animateZoom);
                        }
                        else {
                            __classPrivateFieldGet(this, _Viewport_cancelZoomAnimation, "f").call(this);
                            __classPrivateFieldGet(this, _Viewport_preloadOtherLevelTiles, "f").call(this);
                            this.isZooming = false;
                            resolve();
                        }
                        if (setPointerPosition) {
                            __classPrivateFieldGet(this, _Viewport_moveAnimatedToPointerPosition, "f").call(this, storedPointerToArtworkPos[0], storedPointerToArtworkPos[1], storedPointerPos[0], storedPointerPos[1]);
                        }
                        if (this.moveCallback)
                            this.moveCallback();
                        if (PREVENT_IMAGE_PLACEMENT_BESIDE_BOUNDARIES)
                            __classPrivateFieldGet(this, _Viewport_setPosition, "f").call(this, this.posPercentageX, this.posPercentageY);
                    }
                    else {
                        this.isZooming = false;
                        __classPrivateFieldGet(this, _Viewport_preloadOtherLevelTiles, "f").call(this);
                        if (this.moveCallback)
                            this.moveCallback();
                        if (setCenterPosition) {
                            __classPrivateFieldGet(this, _Viewport_moveAnimated, "f").call(this, -this.posPercentageX, -this.posPercentageY);
                        }
                        resolve();
                    }
                };
                animateZoom();
            });
        });
        _Viewport_moveAnimated.set(this, (moveDistancePercentageX, moveDistancePercentageY, moveAnimTime = MOVE_ANIM_TIME, animationTimingFunction = easeOutSine) => {
            return new Promise((resolve) => {
                const initialPosX = this.posPercentageX;
                const initialPosY = this.posPercentageY;
                const startTime = Date.now();
                __classPrivateFieldGet(this, _Viewport_cancelMoveAnimation, "f").call(this);
                const animateMove = () => {
                    const currentTime = Date.now();
                    const elapsed = currentTime - startTime;
                    const progress = animationTimingFunction(elapsed / moveAnimTime);
                    const currentMoveX = moveDistancePercentageX * progress;
                    const currentMoveY = moveDistancePercentageY * progress;
                    __classPrivateFieldGet(this, _Viewport_setPosition, "f").call(this, initialPosX + currentMoveX, initialPosY + currentMoveY);
                    if (elapsed <= moveAnimTime) {
                        this.moveAnimFrame = requestAnimationFrame(animateMove);
                    }
                    else {
                        resolve();
                    }
                    if (this.moveCallback)
                        this.moveCallback();
                    __classPrivateFieldGet(this, _Viewport_setVisibleTiles, "f").call(this);
                };
                animateMove();
            });
        });
        _Viewport_moveAnimatedToPointerPosition.set(this, (storedPointerToArtworkPosX, storedPointerToArtworkPosY, storedPointerPosX, storedPointerPosY) => {
            const pointerOnViewport = UPDATE_POINTER_POSITION_WHILE_SCROLL_ZOOMING
                ? __classPrivateFieldGet(this, _Viewport_getPointPositionFromViewport, "f").call(this, this.pointerPositionX, this.pointerPositionY)
                : __classPrivateFieldGet(this, _Viewport_getPointPositionFromViewport, "f").call(this, storedPointerPosX, storedPointerPosY);
            const movementX = pointerOnViewport[0] - storedPointerToArtworkPosX;
            const movementY = pointerOnViewport[1] - storedPointerToArtworkPosY;
            __classPrivateFieldGet(this, _Viewport_setPosition, "f").call(this, movementX, movementY);
        });
        Object.defineProperty(this, "moveArtworkToCertainPoint", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (posX, posY) => {
                const zoomMultiplier = 1;
                const posDiffX2 = posX - (this.VIEWPORT_SIZE_INITIAL.x + this.VIEWPORT_SIZE_INITIAL.w / 2);
                const posDiffY2 = posY - (this.VIEWPORT_SIZE_INITIAL.y + this.VIEWPORT_SIZE_INITIAL.h / 2);
                const convertedPos = __classPrivateFieldGet(this, _Viewport_convertPxToPercentage, "f").call(this, posDiffX2 * zoomMultiplier, posDiffY2 * zoomMultiplier);
                __classPrivateFieldGet(this, _Viewport_moveAnimated, "f").call(this, convertedPos[0], convertedPos[1]);
            }
        });
        Object.defineProperty(this, "setPositionByPercentage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (percentageX, percentageY) => {
                __classPrivateFieldGet(this, _Viewport_setPosition, "f").call(this, percentageX, percentageY);
                if (this.moveCallback)
                    this.moveCallback();
                __classPrivateFieldGet(this, _Viewport_setVisibleTiles, "f").call(this);
            }
        });
        Object.defineProperty(this, "setPositionByPercentageAnimated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (percentageX, percentageY) => {
                const destinationX = percentageX - this.posPercentageX;
                const destinationY = percentageY - this.posPercentageY;
                __classPrivateFieldGet(this, _Viewport_moveAnimated, "f").call(this, destinationX, destinationY);
            }
        });
        Object.defineProperty(this, "setFullImageProps", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (props) => {
                this.previousFullImageProps = this.fullImageProps;
                this.fullImageProps = props;
            }
        });
        Object.defineProperty(this, "setViewportSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (viewportSize) => {
                const previousDevicePixelRatio = this.devicePixelRatio;
                this.devicePixelRatio = __classPrivateFieldGet(this, _Viewport_getDevicePixelRatio, "f").call(this);
                if (INCREASE_MAX_ZOOM_REGARDLESS_OF_DPR) {
                    const zoomPercentageMaxForDPR1 = this.zoomLevelsList?.at(-1).sizeRaw || 100;
                    const calculatedMaxZoomPercentage = zoomPercentageMaxForDPR1 * __classPrivateFieldGet(this, _Viewport_roundToNearestHalf, "f").call(this, this.devicePixelRatio);
                    this.zoomPercentageMax = Math.min(calculatedMaxZoomPercentage, MAX_ZOOM_PERCENTAGE);
                }
                this.VIEWPORT_SIZE_INITIAL = {
                    w: viewportSize.w * this.devicePixelRatio,
                    h: viewportSize.h * this.devicePixelRatio,
                    x: viewportSize.x * this.devicePixelRatio,
                    y: viewportSize.y * this.devicePixelRatio,
                };
                if (USE_UNSCALED_VISIBLE_TILES) {
                    this.VIEWPORT_SIZE_UNSCALED = {
                        w: this.VIEWPORT_SIZE_INITIAL.w / this.scaleMin,
                        h: this.VIEWPORT_SIZE_INITIAL.h / this.scaleMin,
                        x: this.VIEWPORT_SIZE_INITIAL.x / this.scaleMin,
                        y: this.VIEWPORT_SIZE_INITIAL.y / this.scaleMin,
                    };
                }
                __classPrivateFieldGet(this, _Viewport_setScale, "f").call(this, this.scale);
                if (previousDevicePixelRatio !== this.devicePixelRatio) {
                    setTimeout(() => {
                        this.setZoomLevelToInitial();
                    }, 0);
                }
                if (this.previewerCallback)
                    this.previewerCallback();
            }
        });
        Object.defineProperty(this, "getViewportSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.VIEWPORT_SIZE;
            }
        });
        Object.defineProperty(this, "getLevel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return this.level;
            }
        });
        Object.defineProperty(this, "centerImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                __classPrivateFieldGet(this, _Viewport_setPosition, "f").call(this, 0, 0);
                __classPrivateFieldGet(this, _Viewport_setVisibleTiles, "f").call(this);
            }
        });
        Object.defineProperty(this, "getZoomPercentage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => Math.round(this.zoomPercentage)
        });
        Object.defineProperty(this, "getZoomPercentageTarget", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => Math.round(this.zoomPercentageTarget)
        });
        _Viewport_countZoomStep.set(this, (step) => {
            return step ? step / 100 + 1 : ZOOM_AMOUNT_MULTIPLIER;
        });
        Object.defineProperty(this, "increaseZoom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (step = undefined) => {
                __classPrivateFieldGet(this, _Viewport_handleZoomValue, "f").call(this, this.zoomPercentage * __classPrivateFieldGet(this, _Viewport_countZoomStep, "f").call(this, step));
                this.zoomPercentageTarget = this.zoomPercentage;
            }
        });
        Object.defineProperty(this, "decreaseZoom", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (step = undefined) => {
                __classPrivateFieldGet(this, _Viewport_handleZoomValue, "f").call(this, this.zoomPercentage / __classPrivateFieldGet(this, _Viewport_countZoomStep, "f").call(this, step));
                this.zoomPercentageTarget = this.zoomPercentage;
            }
        });
        Object.defineProperty(this, "setZoomLevel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (percentage, setPointerPosition = false) => {
                const storedPointerToArtworkPos = __classPrivateFieldGet(this, _Viewport_getPointPositionFromArtwork, "f").call(this, this.pointerPositionX, this.pointerPositionY);
                const storedPointerPos = [this.pointerPositionX, this.pointerPositionY];
                __classPrivateFieldGet(this, _Viewport_handleZoomValue, "f").call(this, percentage);
                this.zoomPercentageTarget = this.zoomPercentage;
                if (setPointerPosition) {
                    __classPrivateFieldGet(this, _Viewport_moveAnimatedToPointerPosition, "f").call(this, storedPointerToArtworkPos[0], storedPointerToArtworkPos[1], storedPointerPos[0], storedPointerPos[1]);
                    if (this.moveCallback)
                        this.moveCallback();
                    if (PREVENT_IMAGE_PLACEMENT_BESIDE_BOUNDARIES)
                        __classPrivateFieldGet(this, _Viewport_setPosition, "f").call(this, this.posPercentageX, this.posPercentageY);
                }
            }
        });
        Object.defineProperty(this, "increaseZoomAnimated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (step = undefined, setPosByPointer = false, zoomAnimTime = 200) => {
                __classPrivateFieldGet(this, _Viewport_zoomAnimated, "f").call(this, this.zoomPercentageTarget * __classPrivateFieldGet(this, _Viewport_countZoomStep, "f").call(this, step), setPosByPointer, false, zoomAnimTime);
            }
        });
        Object.defineProperty(this, "decreaseZoomAnimated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (step = undefined, setPosByPointer = false, zoomAnimTime = 200) => {
                __classPrivateFieldGet(this, _Viewport_zoomAnimated, "f").call(this, this.zoomPercentageTarget / __classPrivateFieldGet(this, _Viewport_countZoomStep, "f").call(this, step), setPosByPointer, false, zoomAnimTime);
            }
        });
        Object.defineProperty(this, "setZoomLevelAnimated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (percentage, setPosByPointer = false, setCenterPosition = false, zoomAnimTime = ZOOM_ANIM_TIME, animationTimingFunction = easeLinear) => {
                __classPrivateFieldGet(this, _Viewport_zoomAnimated, "f").call(this, percentage, setPosByPointer, setCenterPosition, zoomAnimTime, animationTimingFunction);
            }
        });
        _Viewport_convertPercentageToPx.set(this, (percX, percY) => {
            const viewportCenter = __classPrivateFieldGet(this, _Viewport_getViewportCenterPosPx, "f").call(this);
            const convertedX = (percX - viewportCenter[0]) * this.scale;
            const convertedY = (percY - viewportCenter[1]) * this.scale;
            return [convertedX, convertedY];
        });
        _Viewport_convertPxToPercentage.set(this, (pxX, pxY) => {
            const percentageX = ((pxX / this.fullImageProps.width) * 100) / this.scale;
            const percentageY = ((pxY / this.fullImageProps.height) * 100) / this.scale;
            return [percentageX, percentageY];
        });
        _Viewport_cancelMoveAnimation.set(this, () => {
            if (this.moveAnimFrame)
                cancelAnimationFrame(this.moveAnimFrame);
        });
        _Viewport_cancelZoomAnimation.set(this, () => {
            if (this.zoomAnimFrame) {
                cancelAnimationFrame(this.zoomAnimFrame);
                this.isZooming = false;
                this.zoomPercentageTarget = this.zoomPercentage;
            }
        });
        Object.defineProperty(this, "cancelAnimations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                __classPrivateFieldGet(this, _Viewport_cancelMoveAnimation, "f").call(this);
                __classPrivateFieldGet(this, _Viewport_cancelZoomAnimation, "f").call(this);
            }
        });
        Object.defineProperty(this, "movePosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (x, y) => {
                this.cancelAnimations();
                const convertedToPercentage = __classPrivateFieldGet(this, _Viewport_convertPxToPercentage, "f").call(this, x * this.devicePixelRatio, y * this.devicePixelRatio);
                const newPosInPercentageX = this.posPercentageX + convertedToPercentage[0] * MOVE_SPEED_MULTIPLIER;
                const newPosInPercentageY = this.posPercentageY + convertedToPercentage[1] * MOVE_SPEED_MULTIPLIER;
                __classPrivateFieldGet(this, _Viewport_setPosition, "f").call(this, newPosInPercentageX, newPosInPercentageY);
                if (this.moveCallback)
                    this.moveCallback();
                __classPrivateFieldGet(this, _Viewport_setVisibleTiles, "f").call(this);
            }
        });
        Object.defineProperty(this, "movePositionAnimated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (x, y, animTime = MOVE_ANIM_TIME) => {
                const convertedToPercentage = __classPrivateFieldGet(this, _Viewport_convertPxToPercentage, "f").call(this, x, y);
                __classPrivateFieldGet(this, _Viewport_moveAnimated, "f").call(this, convertedToPercentage[0] * MOVE_SPEED_MULTIPLIER, convertedToPercentage[1] * MOVE_SPEED_MULTIPLIER, animTime);
                __classPrivateFieldGet(this, _Viewport_setVisibleTiles, "f").call(this);
            }
        });
        Object.defineProperty(this, "setPointerPosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (x, y) => {
                this.pointerPositionX = x * this.devicePixelRatio;
                this.pointerPositionY = y * this.devicePixelRatio;
            }
        });
        _Viewport_getPointPositionFromArtwork.set(this, (pointPosX, pointPosY) => {
            const posInPx = this.getPosInPx();
            const artworkMovementInPx = __classPrivateFieldGet(this, _Viewport_convertPercentageToPx, "f").call(this, posInPx[0], posInPx[1]);
            const pointerOnArtworkPosRelativeToViewportCenterX = pointPosX - __classPrivateFieldGet(this, _Viewport_getViewportCenterPosPx, "f").call(this)[0] * this.scale - artworkMovementInPx[0];
            const pointerOnArtworkPosRelativeToViewportCenterY = pointPosY - __classPrivateFieldGet(this, _Viewport_getViewportCenterPosPx, "f").call(this)[1] * this.scale - artworkMovementInPx[1];
            return __classPrivateFieldGet(this, _Viewport_convertPxToPercentage, "f").call(this, pointerOnArtworkPosRelativeToViewportCenterX, pointerOnArtworkPosRelativeToViewportCenterY);
        });
        _Viewport_getPointPositionFromViewport.set(this, (pointPosX, pointPosY) => {
            const pointerOnViewportPosRelativeToViewportCenterX = pointPosX - __classPrivateFieldGet(this, _Viewport_getViewportCenterPosPx, "f").call(this)[0] * this.scale;
            const pointerOnViewportPosRelativeToViewportCenterY = pointPosY - __classPrivateFieldGet(this, _Viewport_getViewportCenterPosPx, "f").call(this)[1] * this.scale;
            return __classPrivateFieldGet(this, _Viewport_convertPxToPercentage, "f").call(this, pointerOnViewportPosRelativeToViewportCenterX, pointerOnViewportPosRelativeToViewportCenterY);
        });
        Object.defineProperty(this, "getPointerPositionScaled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return [this.pointerPositionX / this.scale, this.pointerPositionY / this.scale];
            }
        });
        Object.defineProperty(this, "getPosInPx", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __classPrivateFieldGet(this, _Viewport_getPxPosFromPercentagePos, "f").call(this, this.posPercentageX, this.posPercentageY)
        });
        _Viewport_countInitialScaleValue.set(this, () => {
            const percentageX = ((this.VIEWPORT_SIZE_INITIAL.w - (this.VIEWPORT_SIZE_INITIAL.w / 100) * INITIAL_ZOOM_SPACING_PERCENTAGE) /
                this.layers.at(-1).width) *
                100;
            const percentageY = ((this.VIEWPORT_SIZE_INITIAL.h - (this.VIEWPORT_SIZE_INITIAL.w / 100) * INITIAL_ZOOM_SPACING_PERCENTAGE) /
                this.layers.at(-1).height) *
                100;
            return Math.min(percentageX, percentageY);
        });
        Object.defineProperty(this, "setCalculatedMinPercentageVal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.zoomPercentageMin = __classPrivateFieldGet(this, _Viewport_countInitialScaleValue, "f").call(this);
            }
        });
        Object.defineProperty(this, "setZoomLevelToInitial", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (animTime = ZOOM_ANIM_TIME) => {
                this.setZoomLevelAnimated(__classPrivateFieldGet(this, _Viewport_countInitialScaleValue, "f").call(this), false, true, animTime, easeInOutQuad);
                __classPrivateFieldGet(this, _Viewport_moveAnimated, "f").call(this, -this.posPercentageX, -this.posPercentageY, animTime, easeInOutQuad);
            }
        });
        Object.defineProperty(this, "setZoomLevelToMax", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (animTime = ZOOM_ANIM_TIME) => {
                this.setZoomLevelAnimated(this.zoomPercentageMax, false, false, animTime, easeInOutQuad);
            }
        });
        this.useDpr = useDpr;
        this.devicePixelRatio = __classPrivateFieldGet(this, _Viewport_getDevicePixelRatio, "f").call(this);
        this.zoomAnimFrame = null;
        this.moveAnimFrame = null;
        this.layers = layers;
        this.level = initialLevel;
        this.scaleInitial = 1;
        this.scale = this.scaleInitial;
        this.zoomLevelsList = zoomLevelsList;
        this.zoomPercentage = this.zoomLevelsList[initialLevel].sizeRaw * this.scaleInitial;
        this.zoomPercentageTarget = this.zoomPercentage;
        this.fullImageProps = {
            width: this.layers[this.level].width,
            height: this.layers[this.level].height,
        };
        this.previousFullImageProps = this.fullImageProps;
        const viewportSize = initialViewportSize;
        this.VIEWPORT_SIZE_INITIAL = viewportSize;
        this.VIEWPORT_SIZE = {
            x: viewportSize.x / this.scale,
            y: viewportSize.y / this.scale,
            w: viewportSize.w / this.scale,
            h: viewportSize.h / this.scale,
        };
        if (USE_UNSCALED_VISIBLE_TILES) {
            this.VIEWPORT_SIZE_UNSCALED = {
                x: viewportSize.x / this.scaleMin,
                y: viewportSize.y / this.scaleMin,
                w: viewportSize.w / this.scaleMin,
                h: viewportSize.h / this.scaleMin,
            };
        }
        const posX = this.VIEWPORT_SIZE.x + this.VIEWPORT_SIZE.w / 2;
        const posY = this.VIEWPORT_SIZE.y + this.VIEWPORT_SIZE.h / 2;
        const countedPercentagePos = __classPrivateFieldGet(this, _Viewport_getPercentageOfArtworkFocusedCenterPos, "f").call(this, posX, posY);
        this.posPercentageX = countedPercentagePos[0];
        this.posPercentageY = countedPercentagePos[1];
        this.zoomPercentageMin = this.zoomLevelsList[0].sizeRaw * this.scaleMin;
        this.zoomPercentageMax = this.zoomLevelsList?.at(-1).sizeRaw;
        this.storedInitialZoomPercentage = this.zoomPercentageMin;
        this.pointerPositionX = 0;
        this.pointerPositionY = 0;
        this.moveCallback = null;
        this.previewerCallback = null;
        const countedInitialZoomValue = __classPrivateFieldGet(this, _Viewport_countInitialScaleValue, "f").call(this);
        this.zoomPercentageMin = countedInitialZoomValue * this.devicePixelRatio;
        this.setZoomLevel(countedInitialZoomValue);
    }
    setMoveCallback(callback) {
        this.moveCallback = callback;
    }
    setPreviewerCallback(callback) {
        this.previewerCallback = callback;
    }
    setOnVisibleTilesChangeCallback(callback) {
        this.onVisibleTilesChangeCallback = (level, tiles) => {
            callback(level, tiles);
        };
    }
    setClearImagesLevelCache(callback) {
        this.clearImagesLevelCache = (level) => {
            callback(level);
        };
    }
    setOnLevelChangeCallback(callback) {
        this.onLevelChangeCallback = (level) => {
            callback(level);
        };
    }
}
_Viewport_convertDOMPosToMoveDistance = new WeakMap(), _Viewport_roundToNearestHalf = new WeakMap(), _Viewport_getDevicePixelRatio = new WeakMap(), _Viewport_setPositionPercentageValueX = new WeakMap(), _Viewport_setPositionPercentageValueY = new WeakMap(), _Viewport_setPosition = new WeakMap(), _Viewport_setScale = new WeakMap(), _Viewport_getViewportCenterPosPx = new WeakMap(), _Viewport_getViewportCenterPosPxUnscaled = new WeakMap(), _Viewport_getPercentageOfArtworkFocusedCenterPos = new WeakMap(), _Viewport_getPxPosFromPercentagePos = new WeakMap(), _Viewport_getPxPosFromPercentagePosUnscaled = new WeakMap(), _Viewport_getVisibleTilesByLevel = new WeakMap(), _Viewport_getVisibleTilesByLevelUnscaled = new WeakMap(), _Viewport_setVisibleTiles = new WeakMap(), _Viewport_preloadOtherLevelTiles = new WeakMap(), _Viewport_setNextLevel = new WeakMap(), _Viewport_setPrevLevel = new WeakMap(), _Viewport_handleZoomValue = new WeakMap(), _Viewport_zoomAnimated = new WeakMap(), _Viewport_moveAnimated = new WeakMap(), _Viewport_moveAnimatedToPointerPosition = new WeakMap(), _Viewport_countZoomStep = new WeakMap(), _Viewport_convertPercentageToPx = new WeakMap(), _Viewport_convertPxToPercentage = new WeakMap(), _Viewport_cancelMoveAnimation = new WeakMap(), _Viewport_cancelZoomAnimation = new WeakMap(), _Viewport_getPointPositionFromArtwork = new WeakMap(), _Viewport_getPointPositionFromViewport = new WeakMap(), _Viewport_countInitialScaleValue = new WeakMap();
